import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { dark } from '@clerk/themes';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { AppAuthProvider } from './contexts/AppAuthContext';


import {
	ClerkProvider,
} from "@clerk/clerk-react";


const clerkPubKey = (process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '').trim();
const hasClerkKey = clerkPubKey.length > 0;
if (!hasClerkKey && process.env.NODE_ENV !== 'development') {
	throw new Error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const appTree = (
	<AppAuthProvider>
		<React.StrictMode>
			<App />
		</React.StrictMode>
	</AppAuthProvider>
);

if (!hasClerkKey) {
	root.render(
		<div style={{ padding: 24, fontFamily: 'sans-serif' }}>
			<h1>Missing Clerk key</h1>
			<p>Add <code>REACT_APP_CLERK_PUBLISHABLE_KEY</code> to <code>.env</code> in the stryd folder (no spaces around <code>=</code>).</p>
		</div>
	);
} else {
	root.render(
		<ClerkProvider
			appearance={{
				baseTheme: dark,
				variables: { colorPrimary: '#393D1B' }
			}}
			signInUrl="/login"
			signUpUrl="/signup"
			afterSignInUrl="/"
			afterSignUpUrl="/"
			publishableKey={clerkPubKey}
		>
			{appTree}
		</ClerkProvider>
	);
}

serviceWorkerRegistration.register();
